export default "__VITE_ASSET__AQGuWqxD__"